import api from './api';
import type { Service, CreateServiceRequest, UpdateServiceRequest } from '../types';

export const servicesService = {
  async list(): Promise<Service[]> {
    const { data } = await api.get<{ success: boolean; data: { services: Service[] } }>('/services');
    return data.data.services;
  },

  async getAll(): Promise<Service[]> {
    return this.list();
  },

  async getById(id: string): Promise<Service> {
    const { data } = await api.get<{ success: boolean; data: Service }>(`/services/${id}`);
    return data.data;
  },

  async create(serviceData: CreateServiceRequest): Promise<Service> {
    const { data } = await api.post<{ success: boolean; data: { service: Service } }>(
      '/services',
      serviceData
    );
    return data.data.service;
  },

  async update(id: string, serviceData: UpdateServiceRequest): Promise<Service> {
    const { data } = await api.put<{ success: boolean; data: Service }>(
      `/services/${id}`,
      serviceData
    );
    return data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/services/${id}`);
  },
};

export default servicesService;
